// types
import type { AdditionalSelectors } from '../types/AdditionalSelectors';

// store
import * as actionCreators from './actionCreators';
import { MiddlewareManager } from './middlewareManager';
import type { HostActions } from './hostActions';
import { Selectors } from './selectors';

export const customerVehiclePickerCreators = actionCreators;
export let customerVehicleSelector: Selectors;
export let middlewareMgr: MiddlewareManager;

export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors,
    hostActions?: HostActions
): {
    selectors: Selectors;
    middlewareMgr: MiddlewareManager;
} => {
    customerVehicleSelector = new Selectors(appName, additionalSelectors);
    middlewareMgr = new MiddlewareManager(customerVehicleSelector, hostActions);

    return {
        selectors: customerVehicleSelector,
        middlewareMgr
    };
};
